import { gql } from './gql'

/**
 * Ends the shopper's session.
 *
 * This is what "Cerrar sesión" has to call. Navigating to the login screen
 * leaves the session ACTIVE, and because `createSession` **reuses** an active
 * session for a store code, the next login hands back the very session the
 * shopper was trying to leave — same cart, same selections.
 *
 * It also matters beyond the cart. A session whose stored `customer` has been
 * emptied (the `data.type` wipe `CREATE_SESSION` documents) keeps answering
 * `getTotalPromotions` with `customer_code: null`, which the promotions
 * service returns nothing for — silently, with no error. Logging in again
 * cannot heal it, because the login reuses that same session. Expiring is the
 * only way back: verified against staging, where an expired session made the
 * next login mint a fresh one and three promotions reappeared.
 *
 * `id` is the session being ended, not the customer.
 */
export const EXPIRE_SESSION = gql`
  mutation ExpireSession($storefrontName: String!, $id: ID!) {
    expireSession(storefrontName: $storefrontName, id: $id) {
      id
      customerAlias
      status
      finishedAt
    }
  }
`
